import {
    getTestStory,
    regressionTest,
} from "../../../../test-utils/regression";

describe("ux-slider", async () => {
    it("passes the regression test", async () => {
        await regressionTest({
            storyId: getTestStory("slider", "base-slider"),
            componentTag: "ux-slider",
            performActions: async (page) => {
                await page.click(".ux-slider-button-next");
            },
        });
    });
});
